import {SET_SELECTED_FOLDER} from "../types";

export function setSelectedFolder(payload) {
  return {
    type: SET_SELECTED_FOLDER,
    payload
  }
}